export default "__VITE_ASSET__WGJLhCyh__"